module.exports = __webpack_public_path__ + "static/musicalfree-c199bdc84065ee506e5b59e3bcc33de5.jpg";